import { DashboardRoutes } from "@/router/constant";
import { matchPath, useLocation } from "react-router-dom";

export function useSelectedTab(): string {
  const location = useLocation();
  const ROUTES = {
    personal: DashboardRoutes.settings.personal.root.url,
    bank: DashboardRoutes.settings.bank.root.url,
    upgrade: DashboardRoutes.user.upgrade.url,
    terminal: DashboardRoutes.settings.terminal.url,
    shop: DashboardRoutes.settings.shop.url,
    ticketList: DashboardRoutes.settings.tickets.list.url,
    businessAdd: DashboardRoutes.settings.business.add.url,
    business: DashboardRoutes.settings.business.root.url,
  };

  const matchedRoute = Object.values(ROUTES).find((microPaths) => {
    const matchedPath = matchPath({ end: false, path: microPaths }, location.pathname);
    return Boolean(matchedPath);
  });

  const selectedPath = matchedRoute || location.pathname;
  return selectedPath;
}
